export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13551.efd70d0a.jpg";